import React from "react";
import "./App.css";
import Header from "./components/common/Header";
import Weather from "./components/containers/Weather";
import { Route, Switch } from "react-router-dom";
import News from "./components/containers/News";
import Movies from "./components/containers/Movies";
import Sidebar from "./components/common/HamburgerMenu";
import Error from "./components/containers/Error";
import GIFS from "./components/containers/GIFS";
import RandomAdvice from "./components/containers/RandomAdvice";
import Words from "./components/containers/Words";


class App extends React.Component {
  public render() {
    return (
      <div className="App">
        <Sidebar />
        <Header />
        <Switch>
          <Route path="/" component={Words} exact />
          <Route path="/weather" component={Weather} />
          <Route path="/news" component={News} />
          <Route path="/words" component={Words} />
          <Route path="/gifs" component={GIFS} />
          <Route path="/advice" component={RandomAdvice} />
          <Route component={Error} />
        </Switch>
      </div>
    );
  }
}
export default App;
